export function getTypelist(field) {
  const options = {};
  let tempOptions;
  if (field === 'room') {
    tempOptions = pickARoomToTellUsAboutOptions;
  } else if (field === 'damagedAreas') {
    tempOptions = selectAllTheDamagedAreasOptions;
  }

  tempOptions.forEach((option) => {
    options[option.value] = option.label;
  });
  return options;
}

export const pickARoomToTellUsAboutOptions = [
  {
    label: 'Attic/loft',
    selectedLabel: 'Attic/loft',
    value: 'atticOrLoft',
  },
  {
    label: 'Bathroom',
    selectedLabel: 'Bathroom',
    value: 'bathroom',
  },
  {
    label: 'Bedroom',
    selectedLabel: 'Bedroom',
    value: 'bedroom',
  },
  {
    label: 'Den or office',
    selectedLabel: 'Den or office',
    value: 'denOffice',
  },
  {
    label: 'Dining room',
    selectedLabel: 'Dining room',
    value: 'diningRoom',
  },
  {
    label: 'Entrance area or doors',
    selectedLabel: 'Entrance area or doors',
    value: 'entranceDoors',
  },
  {
    label: 'Garage',
    selectedLabel: 'Garage',
    value: 'garage',
  },
  {
    label: 'Family or living room',
    selectedLabel: 'Family or living room',
    value: 'familyLivingRoom',
  },
  {
    label: 'Kitchen',
    selectedLabel: 'Kitchen',
    value: 'kitchen',
  },
  {
    label: 'Laundry room',
    selectedLabel: 'Laundry room',
    value: 'laundryRoom',
  },
  {
    label: 'Mudroom',
    selectedLabel: 'Mudroom',
    value: 'mudroom',
  },
  {
    label: 'Other',
    selectedLabel: 'Other',
    value: 'other',
  }];

export const selectAllTheDamagedAreasOptions = [
  {
    label: 'Cabinetry',
    value: 'cabinetry',
  },
  {
    label: 'Ceiling',
    value: 'ceiling',
  },
  {
    label: 'Electrical',
    value: 'electrical',
  },
  {
    label: 'Flooring',
    value: 'flooring',
  },
  {
    label: 'Plumbing',
    value: 'plumbing',
  },
  {
    label: 'Walls',
    value: 'walls',
  },
  {
    label: 'Lighting',
    value: 'lighting',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
